
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 51.333h28a4.667 4.667 0 004.667-4.666V9.333A4.667 4.667 0 0042 4.667H26.227A6.997 6.997 0 0021.28 6.72l-9.893 9.893a7.004 7.004 0 00-2.054 4.947v25.107A4.667 4.667 0 0014 51.333zm28-4.666H14V23.333h11.667A2.332 2.332 0 0028 21V9.333h14v37.334z","fill-rule":"evenodd"}})])
          )
        }
      }
    